import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'rsuite';
import { optimizationPricesResultSelector } from '../../../../../../../../../reducers/OtimizacaoPrecos';
import { setShowHowWeCalculateModal } from '../../../../../../../../../reducers/OtimizacaoPrecos/optimizationPricesResult';
import styles from './Modal.module.scss';

export const ComoCalculamosModal = () => {
  const dispatch = useDispatch();
  const { tabs } = useSelector(optimizationPricesResultSelector, shallowEqual);
  const show = tabs.analysis.modals.howWeCalculateModal.show;
  const closeHowWeCalculateModal = () => dispatch(setShowHowWeCalculateModal({ show: false }));
  return (
    <Modal show={show} onHide={closeHowWeCalculateModal} className={styles.container} size="md">
      <Modal.Header className={styles.header}>
        <Modal.Title className={styles['modal-title']}>
          <p>Entenda como calculamos os resultados</p>
        </Modal.Title>
        <p className={styles['modal-subtitle']}>
          Os resultados apresentados nesta aba mostram a evolução de Faturamento e Lucro da loja otimizada ao longo do tempo. Quando houver uma loja controle
          selecionada, os gráficos e tabelas também permitem a comparação entre ambas.
        </p>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        <section className={styles.section}>
          <p className={styles.title}>Gráficos de variação:</p>
          <ul>
            <li>O Gráfico de Faturamento e o Gráfico de Lucro exibem a evolução percentual ao longo do tempo.</li>
            <li>Cada linha representa a trajetória da loja otimizada e, quando aplicável, a comparação com a loja controle.</li>
            <li>O primeiro ponto do gráfico corresponde a semana ou do mês anterior à otimização, usado como linha de base para as variações.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <p className={styles.title}>Linha do tempo dos dados:</p>
          <ul>
            <li>A tabela mostra os valores de Faturamento e Lucro, além de suas variações percentuais.</li>
            <li>A primeira coluna corresponde ao período anterior à otimização, podendo ser semana ou mês, de acordo com a visualização selecionada.</li>
            <li>
              As colunas seguintes apresentam a evolução ao longo do tempo, mostrando a performance da loja otimizada e, quando disponível, a comparação com a
              loja controle.
            </li>
            <li>A última coluna Acumulado soma as variações de todo o período, considerando acréscimos e decréscimos.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <p className={styles.title}>Metodologia de cálculo:</p>
          <p>
            O sistema utiliza modelos estatísticos e funções estocásticas para definir os preços otimizados.Isso significa que os cálculos incorporam
            probabilidades e simulações de cenários, em vez de apenas regras fixas.Assim, os resultados são dinâmicos e podem variar conforme as condições de
            mercado se alteram.
          </p>
        </section>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <Button onClick={closeHowWeCalculateModal} appearance="primary">
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
